module.exports = __webpack_public_path__ + "img/h-bgc.a05e4915.png";